import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

const InnerContent: FC = () => <Outlet />;

export default InnerContent;
